<template>
  <div>
    <div v-if="!tickets.length" class="skeleton-wrapper">
      <van-skeleton title :row="7" />
    </div>
    <div v-else class="tickets-wrapper">
      <display-ticket-item
        v-for="item of tickets"
        :key="item.id"
        :value="item"
        @purchase="handleClick"
      />
    </div>
  </div>
</template>
<script>
// import { getSpotsTickets } from '@/api/api-ticket';
import DisplayTicketItem from '@/components/DisplayTicketItem.vue';

export default {
  components: {
    DisplayTicketItem,
  },
  props: {
    tickets: {
      type: Array,
      required: true,
    },
  },
  // data() {
  //   return {
  //     tickets: [],
  //   };
  // },
  // created() {
  //   this.handleGet();
  // },
  methods: {
    handleClick(id) {
      this.$router.push({
        name: 'ticket_detail',
        query: { id, united: '1' },
      });
    },
    // async handleGet() {
    //   try {
    //     const { list } = await getSpotsTickets();
    //     this.tickets = list;
    //   } catch {}
    // },
  },
};
</script>
<style lang="less" scoped>
.skeleton-wrapper {
  padding: 16px 0;
}
.tickets-wrapper {
  padding-bottom: 16px;
}
</style>
